import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import ShippingInstructionRequestViewForm from './ShippingInstructionRequestViewForm'
import ShippingInstructionRequestEditForm from './ShippingInstructionRequestEditForm'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import ShippingInstructionRequestKeys from 'src/constants/locale/key/ShippingInstructionRequest'

const { CngTabs } = components


function EditPage({ showNotification }) {
  const { id } = useParams()
  const { translate } = useTranslation([Namespace.SHIPPING_INSTRUCTION_REQUEST])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let shippingInstructionRequest = translate(
      Namespace.SHIPPING_INSTRUCTION_REQUEST,
      ShippingInstructionRequestKeys.TITLE
    )

    return {
      shippingInstructionRequest
    }
  }

  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <ShippingInstructionRequestViewForm
              showNotification={showNotification}
              id={id}
              onFetchPreSuccess={(datum) => {
              }}
            />
          </Container>
        </Paper>
      </Grid> */}
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.shippingInstructionRequest,
              tabContent: (
                <ShippingInstructionRequestEditForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default EditPage